import React from "react";
import { Box, Flex } from "@chakra-ui/react";
import { Route, Routes, BrowserRouter } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Portfolio from "./pages/Portfolio";
import ContactForm from "./components/ContactForm";

import Cart from "./pages/Cart"; // Import the cart component
// import { ProductProvider } from "./pages/ProductContext";
import ProductDetail from "./pages/ProductDetails";
import { CheckoutProvider } from "./pages/CheckoutContext";
import MultiStepCheckout from "./pages/MultiStepCheckout";

function App() {
    return (
        <BrowserRouter>
            <Flex direction="column" minHeight="100vh">
                <Navbar />
                <Box pt="100px" flex="1">
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/portfolio" element={<Portfolio />} />
                        <Route path="/contact" element={<ContactForm />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/cart" element={<Cart />} />
                        <Route path="/checkout" element={<CheckoutProvider><MultiStepCheckout /></CheckoutProvider>} />
                        <Route path="/product/:id" element={<ProductDetail />} />
                    </Routes>
                </Box>
                <Footer />
            </Flex>
        </BrowserRouter>
    );
}

export default App;
